// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GQLxU","image":"styles_image__yR8aW","title":"styles_title__nB4v3","details":"styles_details__34H8P"};